"use strict";
// (C) 2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.SORT_TARGET_TYPE = exports.ChartSortingWithIntl = void 0;
var ChartSorting_1 = require("./ChartSorting");
Object.defineProperty(exports, "ChartSortingWithIntl", { enumerable: true, get: function () { return ChartSorting_1.ChartSortingWithIntl; } });
var types_1 = require("./types");
Object.defineProperty(exports, "SORT_TARGET_TYPE", { enumerable: true, get: function () { return types_1.SORT_TARGET_TYPE; } });
//# sourceMappingURL=index.js.map